import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'recompose';

import { DOCUMENTATION_TYPES } from '../../../constants';

import { selectCheckInsuranceEligibilityLoading } from '../../../redux/appointmentForm/selectors';
import {
  targetUserSelector,
  isLoggedUserSelector,
  selectIsVerifiedDependentRole,
} from '../../../redux/context/selectors';
import { actions as getUserDocuments } from '../../../redux/profiles/get-user-documents';
import { actions as updateUserDocuments } from '../../../redux/profiles/update-user-documents';
import { actions as uploadUserDocuments } from '../../../redux/profiles/upload-user-documents';
import { actions as deleteUserDocuments } from '../../../redux/profiles/delete-user-documents';
import { selectUserDocumentsList } from '../../../redux/profiles/selectors';
import { manageInsurancesActions } from '../../../redux/manage-insurances/actions/manage-insurances-actions';

const mapStateToProps = state => ({
  targetUser: targetUserSelector(state),
  checkInsuranceLoading: selectCheckInsuranceEligibilityLoading(state),
  userDocuments: selectUserDocumentsList(state),
  canEdit: isLoggedUserSelector(state) || selectIsVerifiedDependentRole(state),
});

const mapDispatchToProps = {
  uploadDocuments: uploadUserDocuments.send,
  updateDocuments: updateUserDocuments.send,
  deleteDocuments: deleteUserDocuments.send,
  deleteDocumentItem: getUserDocuments.deleteItem,
  clearInsuranceRelatedData:
    manageInsurancesActions.clearManageInsuranceRelatedData,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ targetUser, userDocuments }) => {
    const driverLicenseDocuments = userDocuments.filter(
      doc => doc && doc.key === DOCUMENTATION_TYPES.DRIVER_LICENCE,
    );

    return {
      targetUserId: get(targetUser, 'id'),
      targetUserName: get(targetUser, 'displayableName'),
      driverLicenseDocuments,
    };
  }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/enhance.js